module.exports = {
  path: 'forgot-password',
  getComponent(nextState, cb) {
    require.ensure([], require => {
      cb(null, require('./components/index'));
    });
  }
};



// WEBPACK FOOTER //
// ./routes/forgotPassword/index.js